import { useEffect } from 'react';
import axios from 'axios';

const KEY = import.meta.env.VITE_TOKEN_STORAGE_KEY || 'auth_token';

const Loader = () => (
  <div style={{
    display: 'grid', placeItems: 'center', height: '100vh',
    fontFamily: 'system-ui,-apple-system,Segoe UI,Roboto,sans-serif'
  }}>
    <div style={{ textAlign: 'center' }}>
      <div style={{
        width: 42, height: 42, borderRadius: '50%',
        border: '4px solid rgba(0,0,0,0.15)', borderTopColor: 'currentColor',
        margin: '0 auto 12px', animation: 'spin 1s linear infinite'
      }} />
      <div>Completing sign-in�</div>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  </div>
);

export default function OAuthRelay() {
  useEffect(() => {
    (async () => {
      const redirect_url = window.location.href; // includes ?code=... and #_=_

      // --- Popup case: post back and close ---
      if (window.opener) {
        try {
          window.opener.postMessage(
            { source: 'fb-oauth', success: true, redirect_url },
            window.location.origin
          );
        } catch (err) {
          try {
            window.opener.postMessage(
              { source: 'fb-oauth', success: false, error: String(err) },
              window.location.origin
            );
          } catch {}
        }
        window.close();
        return;
      }

      // --- Main tab: hide query, exchange code, route to dashboard ---
      try {
        const clean = window.location.origin + window.location.pathname;
        window.history.replaceState({}, '', clean);
      } catch {}

      try {
        const { data } = await axios.post(
          'https://qa.zingoblast.com/auth/facebook/callback/',
          { redirect_url },
          { headers: { 'Content-Type': 'application/json' } }
        );

        const { access_token, refresh_token, user } = data || {};
        if (!access_token) throw new Error('No access_token in response');

        localStorage.setItem(KEY, access_token);
        localStorage.setItem('auth_token', access_token); // alias for any code reading this
        if (refresh_token) localStorage.setItem('refresh_token', refresh_token);
        if (user) localStorage.setItem('user', JSON.stringify(user));

        window.location.replace('/dashboard');
      } catch (err) {
        console.error('Exchange failed:', err?.response?.status, err?.response?.data || String(err));
        window.location.replace('/login?oauth=failed');
      }
    })();
  }, []);

  return <Loader />;
}
